export default "__VITE_ASSET__D0VskS$C__"